import { gsuService } from "../_services"
import moment from 'moment'
moment.locale('ru')

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,

  state: {
    updating: false,

    lastSendable: null,

    ordinances: {
      status: status.INITIAL,
      list: []
    }, 
    statuses: {
      list: [],
      status: status.INITIAL
    },

    selectedStatus: null,
    selectedSort: 0,
    period: null,
    statperiod: null,
    stat: []
  },

  getters: {
    ordinances ({ ordinances}) {
      return ordinances.list
    },
    statuses: ({ statuses }) => statuses.list,
    isStatusesLoaded: ({ statuses }) => statuses.status == status.LOADED,
  },

  mutations: {
    setLastSendable: (state, sendable) => {
      state.lastSendable = sendable
    },
    setUpdating: (state, value) => {
      state.updating = value
    },
    setOrdinances: ({ ordinances }, payload) => {
      ordinances.list = payload
    },
    setOrdinancesStatus: ({ ordinances }, status) => {
      ordinances.status = status
    },
    setStatuses: ({ statuses }, payload) => {
      statuses.list = payload
    },
    setStatusesStatus: ({ statuses }, status) => {
      statuses.status = status
    },
    selectStatus: (state, payload) => {
      state.selectedStatus = payload
    },
    selectSort: (state, payload) => {
      state.selectedSort = payload
    },
    setPeriod: (state, payload) => {
      state.period = payload
    },
    setStatPeriod: (state, payload) => {
      state.statperiod = payload
    },
    setStat: (state, payload) => {
      state.stat = payload
    }
  },


  actions: {

    INIT: ({ dispatch }, { defaultStatus }) => {
        dispatch('GET_STATUSES', defaultStatus)
        dispatch('LOAD_Ordinances')
    },

    LOAD_Ordinances_ALL: ({ commit }) => {
      return gsuService.listOrdinances().then(data => {
        commit('setOrdinances', data)
        return data
      })  
    },

    LOAD_Ordinances: ({state, commit }) => {
      commit('setOrdinancesStatus', status.LOADING)

      let start = moment().startOf('month').format('YYYY-MM-DD')
      let end = moment().endOf('month').format('YYYY-MM-DD')

      commit('setPeriod', { text: moment().format('MMMM YYYY'), type: 'month', start, end })

      gsuService.listOrdinances(state.period.start, state.period.end).then(data => {
          commit('setOrdinances', data)
          commit('setOrdinancesStatus', status.LOADED)
      })
    },

    LOAD_Ordinances_PERIOD: ({ state, commit }) => {
      gsuService.listOrdinances(state.period.start, state.period.end).then(data => {
          commit('setOrdinances', data)
      })
    },

    GET_STATUSES: ({ state, commit }, defaultStatus) => {
      if(state.statuses.status == status.INITIAL ){
         commit('setStatusesStatus', status.LOADING)
         gsuService.docStatuses().then(data => {
           commit('setStatuses', data)
           commit('setStatusesStatus', status.LOADED)
           commit('selectStatus', data.filter(item => item.name === defaultStatus)[0])
         })
      }
    },

    LOAD_STAT: ({ state, commit }) => {
      if(state.statperiod == null) {
        let start = moment().startOf('month').format('YYYY-MM-DD')
        let end = moment().endOf('month').format('YYYY-MM-DD')
        
        commit('setStatPeriod', { text: moment().format('MMMM YYYY'), type: 'month', start, end })
      }
      gsuService.stat(state.statperiod.start, state.statperiod.end).then(data => {
          commit('setStat', data)
      })
    },

  }
}

